
import AuthCredentials from "./AuthCredentials";

export class AuthService {

    constructor(private repoName: string) {}

    getKey(): string {
        return 'mkalmo.eu-results-app-login-info-key' + this.repoName;
    }

    getAuthCredentials(): AuthCredentials {
        const json = this.getStorage().getItem(this.getKey());
        return json ? AuthCredentials.fromRaw(json) : new AuthCredentials('', '');
    }

    isLoggedIn(): boolean {
        return !!this.getStorage().getItem(this.getKey());
    }

    setLoginInfo(loginInfo: AuthCredentials): void {
        this.getStorage().setItem(this.getKey(), JSON.stringify(loginInfo));
    }

    logOut() {
        this.getStorage().removeItem(this.getKey());
    }

    private getStorage() {
        return localStorage;
    }
}
